// 📄 pages/Admin/AdminRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { RefreshCw } from 'lucide-react';
import { useAuth } from '../../context/AuthContext.tsx';

// Protección a nivel de ruta: sin importar cómo se llegue a /admin
// (clic en el navbar o URL escrita a mano), solo entra role === 'admin'.
export default function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user, profile, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[rgb(var(--c-bg))] text-gray-400 flex flex-col items-center justify-center gap-3">
        <RefreshCw className="w-8 h-8 animate-spin text-blue-500" />
        <p className="text-sm">Verificando permisos...</p>
      </div>
    );
  }

  if (!user || profile?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
